<template>

  <v-dialog
    v-model     = "isDialogOpen"
    width       = "400px"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>

        <v-form
          v-model = "formIsValid"
          class   = "form"
        >
          <v-jsf
            v-model       = "model"
            :schema       = "schema"
            :options      = "options"
          >
          </v-jsf>
          <template slot="imageProp">
          </template>
        </v-form>

      </v-card-text>
      <v-card-actions>

        <v-spacer></v-spacer>

        <v-btn
          elevation = "0"
          color     = "error"
          @click    = "onReject"
        >
          Cancel
        </v-btn>

        <v-btn
          elevation = "0"
          color     = "primary"
          :disabled = "!formIsValid"
          @click    = "onAccept"
        >
          Submit
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {

  // #region Properties

  name: 'OutputConfigurationDialog',
  data() {
    return {
      isDialogOpen: false,

      title:   undefined,
      model:   undefined,
      schema:  undefined,
      options: undefined,

      formIsValid: false,

      resolve: undefined
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onReject() {
      this.isDialogOpen = false;
      this.resolve(undefined);
    },

    onAccept() {
      this.isDialogOpen = false;
      this.resolve(this.model);
    },

    // #endregion Events

    configureOutput(
      title,
      model,
      schema,
      options
    ) {
      this.title = title;
      this.model = model;
      this.schema = schema;
      this.options = options;

      this.isDialogOpen = true;

      return new Promise(resolve => {
        this.resolve = resolve;
      });
    }

  }

  // #endregion Methods

}

</script>
